import React, { Children } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Award } from 'lucide-react';
import { motion } from 'framer-motion';
const ProgramasClientes = () => {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <div className="flex flex-col min-h-screen w-full bg-benefika-light" data-id="element-267">
      <Header data-id="element-268" />
      <main className="flex-grow" data-id="element-269">
        {/* Hero Section */}
        <section className="relative bg-benefika-charcoal text-white py-20 md:py-28 overflow-hidden" data-id="element-270">
          <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-271">
            <div className="absolute top-0 right-0 w-96 h-96 bg-benefika-teal/20 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/3" data-id="element-272"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-benefika-amber/10 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/3" data-id="element-273"></div>
          </div>

          <div className="container mx-auto px-4 text-center relative z-10" data-id="element-274">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6" data-id="element-275">
              Nuestros Casos de Éxito
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-276">
              Conozca los programas de fidelización que administramos y cómo
              ayudamos a las marcas a conectar profundamente con sus
              comunidades.
            </motion.p>
          </div>
        </section>

        {/* Programas de Fidelización Section */}
        <section className="py-20 md:py-32 bg-white" data-id="element-277">
          <div className="container mx-auto px-4" data-id="element-278">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-16" data-id="element-279">
              <div className="w-20 h-20 bg-benefika-teal/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-280">
                <Award className="text-benefika-teal w-10 h-10" data-id="element-281" />
              </div>
              <h2 className="text-3xl md:text-5xl font-bold text-benefika-charcoal mb-6 tracking-tight" data-id="element-282">
                Programas que Administramos
              </h2>
              <p className="text-lg text-benefika-gray max-w-3xl mx-auto leading-relaxed" data-id="element-283">
                Gestionamos ecosistemas de beneficios innovadores que fortalecen
                la relación entre empresas, comunidades y sus usuarios.
              </p>
            </motion.div>

            <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true,
            margin: '-50px'
          }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8" data-id="element-284">
              {/* Sambocard */}
              <motion.div variants={cardVariants} className="bg-benefika-light p-8 rounded-3xl border border-gray-100 flex flex-col hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-285">
                <div className="flex justify-center mb-6" data-id="element-286">
                  <div className="w-28 h-28 bg-white rounded-full p-2 shadow-sm group-hover:scale-105 transition-transform duration-300" data-id="element-287">
                    <img src="https://cdn.magicpatterns.com/uploads/3BRRyX9ye4Zv96uTGcrhFu/Sambocard_-_Logo_Instagram.jpg" alt="Logo Sambocard" className="w-full h-full object-contain rounded-full" data-id="element-288" />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-benefika-charcoal mb-3 text-center" data-id="element-289">
                  Sambocard
                </h3>
                <p className="text-benefika-gray mb-8 flex-grow text-center leading-relaxed" data-id="element-290">
                  Programa de beneficios exclusivo para quienes residen,
                  trabajan, estudian o se sienten parte de Samborondón.
                </p>
                <a href="https://www.sambocard.com/" target="_blank" rel="noopener noreferrer" className="w-full bg-white border-2 border-benefika-teal text-benefika-teal font-semibold py-3 px-6 rounded-xl hover:bg-benefika-teal hover:text-white transition-colors text-center" data-id="element-291">
                  Ver Programa
                </a>
              </motion.div>

              {/* Elite Creator Pass */}
              <motion.div variants={cardVariants} className="bg-benefika-light p-8 rounded-3xl border border-gray-100 flex flex-col hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-292">
                <div className="flex justify-center mb-6" data-id="element-293">
                  <div className="w-28 h-28 bg-white rounded-full p-2 shadow-sm group-hover:scale-105 transition-transform duration-300" data-id="element-294">
                    <img src="https://cdn.magicpatterns.com/uploads/qhrLWU3USevQjxaZ2oHt7M/Elite_-_Logo_Instagram.jpg" alt="Logo Elite Creator Pass" className="w-full h-full object-contain rounded-full" data-id="element-295" />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-benefika-charcoal mb-3 text-center" data-id="element-296">
                  Elite Creator Pass
                </h3>
                <p className="text-benefika-gray mb-8 flex-grow text-center leading-relaxed" data-id="element-297">
                  Membresía exclusiva para creadores de contenido y
                  profesionales digitales con beneficios especializados.
                </p>
                <a href="https://www.elitecreatorpass.com/" target="_blank" rel="noopener noreferrer" className="w-full bg-white border-2 border-benefika-teal text-benefika-teal font-semibold py-3 px-6 rounded-xl hover:bg-benefika-teal hover:text-white transition-colors text-center" data-id="element-298">
                  Ver Programa
                </a>
              </motion.div>

              {/* Emprende Full Pass */}
              <motion.div variants={cardVariants} className="bg-benefika-light p-8 rounded-3xl border border-gray-100 flex flex-col hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-299">
                <div className="flex justify-center mb-6" data-id="element-300">
                  <div className="w-28 h-28 bg-white rounded-full p-2 shadow-sm group-hover:scale-105 transition-transform duration-300" data-id="element-301">
                    <img src="https://cdn.magicpatterns.com/uploads/pqb13Vw3BftKwcBeEuvpH2/Emprende_-_Logo_Instagram.jpg" alt="Logo Emprende Full Pass" className="w-full h-full object-contain rounded-full" data-id="element-302" />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-benefika-charcoal mb-3 text-center" data-id="element-303">
                  Emprende Full Pass
                </h3>
                <p className="text-benefika-gray mb-8 flex-grow text-center leading-relaxed" data-id="element-304">
                  Programa de beneficios diseñado específicamente para potenciar
                  a la comunidad de emprendedores.
                </p>
                <a href="https://www.emprendefullpass.com/" target="_blank" rel="noopener noreferrer" className="w-full bg-white border-2 border-benefika-teal text-benefika-teal font-semibold py-3 px-6 rounded-xl hover:bg-benefika-teal hover:text-white transition-colors text-center" data-id="element-305">
                  Ver Programa
                </a>
              </motion.div>

              {/* Club Ahorra */}
              <motion.div variants={cardVariants} className="bg-benefika-light p-8 rounded-3xl border border-gray-100 flex flex-col hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-306">
                <div className="flex justify-center mb-6" data-id="element-307">
                  <div className="w-28 h-28 bg-white rounded-full p-2 shadow-sm group-hover:scale-105 transition-transform duration-300" data-id="element-308">
                    <img src="https://cdn.magicpatterns.com/uploads/totueACZWqYv3ma4e6zU4D/Logo_Instagrma_Club_Ahorra.jpg" alt="Logo Club Ahorra" className="w-full h-full object-contain rounded-full" data-id="element-309" />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-benefika-charcoal mb-3 text-center" data-id="element-310">
                  Club Ahorra
                </h3>
                <p className="text-benefika-gray mb-8 flex-grow text-center leading-relaxed" data-id="element-311">
                  Club de beneficios y descuentos estratégicos para maximizar
                  los ahorros diarios de sus miembros.
                </p>
                <a href="https://www.clubahorra.com/" target="_blank" rel="noopener noreferrer" className="w-full bg-white border-2 border-benefika-teal text-benefika-teal font-semibold py-3 px-6 rounded-xl hover:bg-benefika-teal hover:text-white transition-colors text-center" data-id="element-312">
                  Ver Programa
                </a>
              </motion.div>

              {/* LevelUp Play */}
              <motion.div variants={cardVariants} className="bg-benefika-light p-8 rounded-3xl border border-gray-100 flex flex-col hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-313">
                <div className="flex justify-center mb-6" data-id="element-314">
                  <div className="w-28 h-28 bg-slate-900 rounded-full p-4 shadow-sm group-hover:scale-105 transition-transform duration-300 flex items-center justify-center" data-id="element-315">
                    <span className="text-cyan-400 font-extrabold text-sm text-center leading-tight tracking-tight" data-id="element-316">
                      LevelUp
                      <br data-id="element-317" />
                      Play
                    </span>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-benefika-charcoal mb-3 text-center" data-id="element-318">
                  LevelUp Play
                </h3>
                <p className="text-benefika-gray mb-8 flex-grow text-center leading-relaxed" data-id="element-319">
                  Programa de recompensas para la comunidad gamer del Ecuador.
                  Participa en torneos, gana premios y sube de nivel con cada
                  partida.
                </p>
                <a href="https://levelup.aede.ec/" target="_blank" rel="noopener noreferrer" className="w-full bg-white border-2 border-benefika-teal text-benefika-teal font-semibold py-3 px-6 rounded-xl hover:bg-benefika-teal hover:text-white transition-colors text-center" data-id="element-320">
                  Ver Programa
                </a>
              </motion.div>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer data-id="element-321" />
    </div>;
};
export default ProgramasClientes;